module.exports = __webpack_public_path__ + "static/contact-70cd761f2867112057053664e2bcc437.png";